// export const API_URL = "https://mk5guwae7g.eu-west-1.awsapprunner.com/api";

import { ClientUnassignedId } from '../types';

export const isDevelopEnv =
    import.meta.env.VITE_REACT_APP_SERVER_STAGE === 'develop' ||
    import.meta.env.MODE === 'development';

export const isE2ERunning = () => Boolean(navigator?.webdriver);

export const UPHEAL_API_URL = `${
    import.meta.env.VITE_REACT_APP_UPHEAL_API_URL
}`;
export const UPHEAL_GRAPHQL_API_URL = UPHEAL_API_URL.replace(
    /\/api$/,
    '/graphql',
);

export const UPHEAL_SIGNUP_URL = `${
    import.meta.env.VITE_REACT_APP_UPHEAL_API_SIGNUP_URL
}`;

export const THERAPIST_REGISTRATION_PATH = '/user/registration';
// Admin interface requires a specific sign in path injected as an environment variable
export const SIGN_IN_PATH = `${
    import.meta.env.VITE_REACT_APP_UPHEAL_API_SIGNIN_PATH ?? '/auth/signin'
}`;
export const SSO_SIGN_IN_PATH = '/auth/sso/signin';
export const SSO_DOMAIN_SIGN_IN_PATH = '/auth/sso/admin/signin';
export const OTP_SIGN_IN_PATH = '/auth/otp/signin';
export const OTP_CLIENT_SIGN_IN_PATH = '/auth/otp/client-signin';
export const SIGN_IN_VERIFY_PATH = '/auth/signin/verify';
export const SIGN_UP_PATH = '/auth/signup';
export const SIGN_UP_V2_PATH = '/auth/v2/signup';
export const SIGN_UP_WITH_GOOGLE_V2_PATH = '/auth/v2/signup/google';
export const REFRESH_TOKEN_PATH = '/auth/refresh';
export const ME_PATH = '/user/me';
export const THERAPY_SESSION_LIST_PATH = '/v2/therapy-session/list';
export const THERAPY_SESSION_PATH = '/therapy-session';
export const THERAPY_SESSION_V2_PATH = '/v2/therapy-session';
export const THERAPY_SESSION_DETAIL_PATH = '/therapy-session/detail';
export const USERS_LIST_PATH = '/user/mygroup';
export const CREATE_USER_PATH = '/user/create';
export const LOGOUT_PATH = '/logout';
export const USER_PATH = '/user';
export const UPDATE_PASSWORD_PATH = '/user/v2/me/password';
export const SIGN_IN_CLIENT_PATH = '/auth/therapy-session/signin';
export const REQUIRED_CONSENTS_PATH = '/consent/list/required';
export const ACCEPTED_CONSENTS_PATH = '/consent/list/accepted';
export const ACCEPT_CONSENTS_PATH = '/consent/accept';
export const SKIP_CLIENT_CONSENTS_PATH = '/consent/accept-externally';
export const INVITE_LINK_PATH = '/invite/app/link';
export const VALIDATE_INVITE_PATH = '/invite/link';
export const VALIDATE_EMAIL_CODE_PATH = '/invite/code';
export const VERIFY_AUTH_PATH = '/auth/verify';
export const VERIFY_CONFIRM_AUTH_PATH = '/auth/v2/verify/confirm';
export const PASSWORD_RESET_PATH = '/password-reset';
export const PASSWORD_RESET_LINK_PATH = '/password-reset/link';
export const PRIVATE_ROOM_LINK_PATH = '/auth/private-room/entry';
export const ORGANIZATIONS_PATH = '/organizations';
export const ORGANIZATION_PREF_PATH = '/preferences/organization';
export const USER_DATA_PATH = '/user-data';
export const MULTIPART_SESSION_UPLOAD_PATH =
    '/therapy-session-upload/multipart';
export const MULTIPART_CHART_DATA_SP_UPLOAD_PATH =
    '/chart-import-upload/multipart';
export const SELF_SCHEDULE_SIGN_IN_PATH = '/auth/schedule/signin';
export const REQUEST_MAGIC_LINK = '/client-portal/request-magic-link';

// This regex will enforce these rules:
//  * At least one upper case English letter, (?=.*? [A - Z])
//  * At least one lower case English letter, (?=.*? [a - z])
//  * At least one digit, (?=.*? [0 - 9])
//  * Minimum eight in length.{ 8,} (with the anchors)
export const PASSWORD_REGEXP = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;

// export const clientVideoUrl = (clientId: string) => {
//     return `${APP_HOST}/client/${clientId}`;
// }

export const CLIENT_GENERIC_UNASSIGNED_URL_PART = 'unassigned';

/**
 * These are used only to distinguish initial selection before recording in AR.
 * They are no intended to be used in normal routing or session detail or any other context.
 */
export const CLIENT_INDIVIDUAL_UNASSIGNED_URL_PART = `${CLIENT_GENERIC_UNASSIGNED_URL_PART}-individual`;
export const CLIENT_COUPLE_UNASSIGNED_URL_PART = `${CLIENT_GENERIC_UNASSIGNED_URL_PART}-couple`;

export const TRANSCRIPT_UTTERANCE_SEARCH_PARAM = 'transcript-utterance';

export const createSessionDetailRoute = (
    contractId: undefined | string,
    sessionId: string,
    transcriptUtteranceIndex?: number,
) => {
    const basePath = `/detail/${
        contractId ?? CLIENT_GENERIC_UNASSIGNED_URL_PART
    }/${sessionId}`;

    if (transcriptUtteranceIndex !== undefined) {
        return `${basePath}?${TRANSCRIPT_UTTERANCE_SEARCH_PARAM}=${transcriptUtteranceIndex}`;
    }

    return basePath;
};

export const createContractDetailRoute = (contractId: string) => {
    if (contractId === ClientUnassignedId) {
        // this should be already handled at call site, but in case we slip up
        // it's better to show dashboard then 404
        return '/';
    }

    return `/detail/${contractId}`;
};
